export default function Marquee() {
    const items = [
        "NAVSEA Certified Welding",
        "ABS Certified Welders",
        "MIL-SPEC Compliant",
        "Submarine & Surface Combatant",
        "CuNi · Stainless · Carbon · Aluminum",
        "MIG · TIG · Flux Core · Stick",
        "Mobilized Anywhere in the U.S.",
    ];
    const loop = [...items, ...items];
    return (
        <div
            data-testid="trust-marquee"
            className="relative border-y border-white/10 bg-brand-surface/40 overflow-hidden z-10"
        >
            <div className="marquee-track py-5">
                {loop.map((text, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-6 px-6 whitespace-nowrap"
                    >
                        <span className="font-display font-black text-white/90 uppercase tracking-tight text-2xl md:text-3xl">
                            {text}
                        </span>
                        <span className="text-brand-blue font-mono text-2xl">
                            ✦
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}
